import React from 'react';
import * as Icons from 'lucide-react';
import { ChannelIconProps } from './ChannelIcon.d';



const ChannelIcon: React.FC<ChannelIconProps> = ({ iconName, className = '' }) => {
  const Icon = (Icons as any)[iconName];
  return Icon ? <Icon className={className} /> : null;
};
export default ChannelIcon;